module.exports = __webpack_public_path__ + "static/img/icon-home.79b6f32f.png";